import React, { useEffect, useRef, useState } from "react";
import { getAWSUrl } from "../api/core";
import "./banner.css";
import Global from "../../global";
import Share from "../share/share";
import { Link } from "react-router-dom";
import {
  favourited,
  favourites,
  getPercentage,
  getSeasonWatch,
  videoTitle,
} from "../javascript/function";
import { UserStore } from "../store/store";
import LazyDiv from "../lazy/lazydiv";
import { useTranslation } from "react-i18next";

const Banner = (props) => {
  const [ban, setBan] = useState([]);
  const mounted = useRef(false);
  const currentUser = UserStore.useState((s) => s.user);
  const { t } = useTranslation(["translation"]);
  const { finalResult, videoId } = getSeasonWatch(
    props.data.items,
    currentUser.WATCHHISTORY,
    props.match.params.AppId
  );
  const watchRef = useRef(finalResult);
  const nameRef = useRef(
    videoTitle(videoId, currentUser.WATCHHISTORY)
      ? videoTitle(videoId, currentUser.WATCHHISTORY)
      : t("btn_Watch")
  );
  const perRef = useRef(
    finalResult && videoId
      ? getPercentage(videoId, currentUser.WATCHHISTORY)
      : 0
  );

  useEffect(() => {
    mounted.current = true;
    if (mounted.current) {
      setBan(props.data);
    }

    return () => {
      mounted.current = false;
    };
  }, [props.data]);

  if (ban !== null) {
    return (
      <div
        className={
          Global.TYPE === "OTT"
            ? "banner-wrapper no-top-padding"
            : "banner-wrapper no-news-padding"
        }
      >
        <LazyDiv
          className="banner-wrap justify-content-between align-items-center"
          orient={"landscape"}
          style={{
            backgroundImage: Global.SHADING
              ? `url()`
              : props.image
              ? `url(` + getAWSUrl() + props.image + `)`
              : `url()`,
          }}
        >
          <img
            src={props.image ? getAWSUrl() + props.image : ""}
            style={{ display: "none" }}
            alt=""
          />
          {/* <video controls="" autoplay="" name="media" loop="" style={{position:"absolute"}}><source src="https://templates.iqonic.design/streamit/frontend/html/video/sample-video.mp4" type="video/mp4"/></video> */}
          <div
            className={Global.SHADING ? "left-wrap" : "left-wrap left-shade"}
          >
            <span className={Global.TEXTSHADOW ? "rnd" : "rnd no-text-shadow"}>
              {ban.rating}
            </span>
            <h2 className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
              {ban.displayName}
            </h2>

            <div className="bottoming">
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                <b className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
                  {ban.genre}
                </b>
              </span>
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                {ban.secondTag}
              </span>
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                <b className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
                  {ban.firstTag}
                </b>
              </span>
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                <b className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
                  {ban.ageRating}
                </b>
              </span>
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                {ban.items ? ban.items.length + " " + t("label_Seasons") : ""}
              </span>
            </div>
            <p
              className={
                Global.TEXTSHADOW ? "starring" : "starring no-text-shadow"
              }
            >
              {t("label_Starring") + " : "}
              {ban.starring}
            </p>
            <p
              className={
                Global.TEXTSHADOW ? "starring" : "starring no-text-shadow"
              }
            >
              {t("label_Audio") + " : "}
              {ban.audio}
            </p>
            <p className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
              {ban.description}
            </p>

            {/* <a href="movie-details.html" className="btn btn-hover mr-2"><i className="ri-order-play-fill mr-2" aria-hidden="true" />Watch Trailer</a> */}
            <Link
              to={
                Global.BEW &&
                ban.items != null &&
                Global.RPB &&
                ban.items.length > 0
                  ? watchRef.current
                    ? watchRef.current
                    : "/" +
                      props.match.params.AppId +
                      "/season/watch/" +
                      ban.items[0].itemid
                  : Global.BEW &&
                    !Global.RPB &&
                    ban.items &&
                    ban.items.length > 0
                  ? "/" +
                    props.match.params.AppId +
                    "/season/watch/" +
                    ban.items[0].itemid
                  : !Global.BEW &&
                    !Global.RPB &&
                    ban.items != null &&
                    ban.items.length > 0
                  ? "/" +
                    props.match.params.AppId +
                    "/season/watch/" +
                    ban.items[0].itemid
                  : ""
              }
              className="btn btn-hover"
            >
              <i className="fa fa-play mr-2" aria-hidden="true" />
              {Global.RPB ? nameRef.current : t("btn_Watch")}

              <div className="cwwrapper transparent">
                <div
                  className="cwprogress whited"
                  style={{
                    width: Global.RPB
                      ? parseInt(perRef.current) + "%"
                      : 0 + "%",
                  }}
                ></div>
              </div>
            </Link>
            {Global.FAVOURITES ? (
              <Link
                to="#!"
                className="icon-bttn"
                onClick={(event) => {
                  favourites(event, ban, "page");
                }}
              >
                <i
                  className={
                    favourited(ban._id, currentUser.FAVOURITES)
                      ? "ri-check-fill text-white"
                      : "ri-add-line text-white"
                  }
                />
              </Link>
            ) : (
              ""
            )}
            {Global.SOS ? (
              <Link to="#!" className="icon-bttn share">
                <i className="ri-share-line text-white" />{" "}
                <Share
                  type={"season"}
                  details={ban}
                  title={ban.displayName}
                  imaged={getAWSUrl() + props.image}
                  {...props}
                ></Share>
              </Link>
            ) : (
              ""
            )}
            {Global.OFFLINE ? (
              <Link to="#!" className="icon-bttn">
                <i className="ri-download-line text-white" />
              </Link>
            ) : (
              ""
            )}
          </div>
          <LazyDiv
            orient={"landscape"}
            className={Global.SHADING ? "right-wrap rightshade" : ""}
            style={{
              backgroundImage: !Global.SHADING
                ? `url()`
                : props.image
                ? `url(` + getAWSUrl() + props.image + `)`
                : `url()`,
            }}
          >
            {/*  <video id="myVideo" autoPlay="autoPlay" loop="loop" muted={true} >
             <source src="images/video1.mp4" type="video/mp4"></source>
         </video> */}
          </LazyDiv>
        </LazyDiv>
      </div>
    );
  } else {
    return <div style={{ minHeight: "250px" }}></div>;
  }
};

export default Banner;
